<script setup lang="ts">
import KTooltip from '@/components/tooltips/KTooltip.vue';
</script>

<template>
  <KTooltip
    :class="$style.kParentTooltip"
    data-testid="kParentTooltip"
    activator="parent"
  >
    <slot></slot>
  </KTooltip>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

html .kParentTooltip {
}
</style>
